import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import Stack from "@mui/material/Stack";
import type {ReservationDaySlice, ReservationStatus} from "crqlar-react-common/dist/models/reservation/reservation.model";
import type {Resource} from "crqlar-react-common/dist/models/resource/resource.model";
import {endOfDay, startOfDay} from "crqlar-react-common/dist/utils/date.util";
import {useTranslation} from "react-i18next";
import {RightSidebarFloatingPanel} from "../../../layout/rightSidebar/RightSidebarFloatingPanel";
import {RightSidebarPanelHeader} from "../../../layout/rightSidebar/RightSidebarPanelHeader";
import {RightSidebarPanelButton} from "../../../layout/rightSidebar/RightSidebarRail";
import RestaurantOccupancyStats from "../../calendar/RestaurantOccupancyStats";
import {useTimeframe} from "../../floorPlan/v2/hooks/useTimeframe";

interface FloorplanStatsButtonProps {
    sectorId: string;
    restaurant: Resource;
    date: Date;
    statuses: ReservationStatus[];
}

export function FloorplanStatsButton({sectorId, restaurant, date, statuses}: FloorplanStatsButtonProps) {
    const {t} = useTranslation();
    const {reservationDaySlice} = useTimeframe();

    return (
        <RightSidebarPanelButton
            icon={<AnalyticsOutlinedIcon/>}
            label={t("Statistics")}
            renderPanel={close => (
                <RightSidebarFloatingPanel sx={{overflow: "hidden"}}>
                    <RightSidebarPanelHeader title={t("Statistics")} onClose={close}/>
                    <Stack sx={{flex: 1, minHeight: 0, overflowY: "auto", px: 2, pb: 2}}>
                        <RestaurantOccupancyStats
                            fullWidth
                            scope={{
                                sectorId,
                                resources: [restaurant],
                                fromDate: startOfDay(date),
                                toDate: endOfDay(date),
                                statuses,
                                daySlice: reservationDaySlice as ReservationDaySlice,
                                timelineSpan: "day",
                            }}
                        />
                    </Stack>
                </RightSidebarFloatingPanel>
            )}
        />
    );
}
